import { RadioCardItem, RadioCardRoot } from '@/components/ui/radio-card';
import { Button, Flex, Heading, VStack } from '@chakra-ui/react';
import { EditPencil, Globe } from 'iconoir-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type DnaMethod = 'write' | 'scan';

interface BrandDnaChoiceStepProps {
  onContinue: (method: DnaMethod) => void;
  hideTitle?: boolean;
}

const BrandDnaChoiceStep = ({ onContinue, hideTitle = false }: BrandDnaChoiceStepProps) => {
  const { t } = useTranslation();
  const [method, setMethod] = useState<DnaMethod>('scan');

  return (
    <VStack gap={6} align="stretch">
      {!hideTitle && <Heading size="md">{t('settings.brandDna.choice.title')}</Heading>}

      <RadioCardRoot
        value={method}
        onValueChange={(details) => setMethod(details.value as DnaMethod)}
      >
        <VStack gap={3} align="stretch">
          <RadioCardItem
            value="scan"
            icon={<Globe width={20} height={20} />}
            label={t('settings.brandDna.choice.scanLabel')}
            description={t('settings.brandDna.choice.scanDescription')}
            fontSize="md"
            minH="80px"
            p={5}
          />
          <RadioCardItem
            value="write"
            icon={<EditPencil width={20} height={20} />}
            label={t('settings.brandDna.choice.writeLabel')}
            description={t('settings.brandDna.choice.writeDescription')}
            fontSize="md"
            minH="80px"
            p={5}
          />
        </VStack>
      </RadioCardRoot>

      <Flex justify="flex-end">
        <Button onClick={() => onContinue(method)}>{t('settings.brandDna.choice.continue')}</Button>
      </Flex>
    </VStack>
  );
};

export default BrandDnaChoiceStep;
